import PdfFileIcon from '@/svgs/pdf_file.webp';
import WordFileIcon from '@/svgs/word_file.webp';
import ImageFileIcon from '@/svgs/image_file.svg';

const FILE_ICONS = {
  'application/pdf': 'bi bi-file-earmark-pdf-fill',
  'PDF':             'bi bi-file-earmark-pdf-fill',
  'image/png':       'bi bi-image-fill',
  'image/jpeg':      'bi bi-image-fill',
  'Image':           'bi bi-image-fill',
}

const DEFAULT_ICON = 'bi bi-file-earmark-word-fill'

// Same mime-type/type keys as FILE_ICONS above, resolved to the image assets
// used by the card file-list UI instead of an icon-font class.
const FILE_ICON_SRC = {
  'application/pdf': PdfFileIcon,
  'PDF':             PdfFileIcon,
  'image/png':       ImageFileIcon,
  'image/jpeg':      ImageFileIcon,
  'Image':           ImageFileIcon,
}

const DEFAULT_FILE_ICON_SRC = WordFileIcon

function GetFileIcon(mimeType) {
  return FILE_ICONS[mimeType] ?? DEFAULT_ICON
}

function GetFileIconSrc(mimeType) {
  return FILE_ICON_SRC[mimeType] ?? DEFAULT_FILE_ICON_SRC
}

function FormatDateForForm(date) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 19)
    .replace('T', ' ')
}

export default {
    GetFileIcon, GetFileIconSrc, FormatDateForForm
}